import { render, staticRenderFns } from "./MemberDayIndex.vue?vue&type=template&id=3128a453&scoped=true"
import script from "./MemberDayIndex.vue?vue&type=script&lang=js"
export * from "./MemberDayIndex.vue?vue&type=script&lang=js"
import style0 from "./MemberDayIndex.vue?vue&type=style&index=0&id=3128a453&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3128a453",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3128a453')) {
      api.createRecord('3128a453', component.options)
    } else {
      api.reload('3128a453', component.options)
    }
    module.hot.accept("./MemberDayIndex.vue?vue&type=template&id=3128a453&scoped=true", function () {
      api.rerender('3128a453', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/memberDay/MemberDayIndex.vue"
export default component.exports